export default "__VITE_ASSET__Dq8qVU9U__"